import React from 'react';

const Disclaimer = ({ className = "" }) => (
    <p className={`text-xs text-slate-500 mt-6 text-center ${className}`}>
        Disclaimer: This tool is independently developed by Mr Joel's Teaching Tools and is not affiliated, associated, authorized, endorsed by, or in any way officially connected with Teachers Pay Teachers (TPT). The app is designed to support TPT sellers in improving their listings.
    </p>
);

export default Disclaimer;